import { defineStore, acceptHMRUpdate } from 'pinia';
import { storeConfig } from '@/shared/storeConfig';

const paymentsStore = () => {
  const isLoading = ref<boolean>(false);
  const payments = ref<PaymentsFromApi>({
    deposit: [],
    withdraw: [],
  });

  const fallback = ref<FallbackPayments>({
    fallback_enabled: false,
    whitelist_users: false,
    fallback_all_users: false,
  });

  function $reset() {
    isLoading.value = false;
    payments.value = {
      deposit: [],
      withdraw: [],
    };
    fallback.value = {
      fallback_enabled: false,
      whitelist_users: false,
      fallback_all_users: false,
    };
  }

  return {
    $reset,
    isLoading,
    payments,
    fallback,
  };
};

export const usePaymentsStore = defineStore(
  'payments',
  paymentsStore,
  storeConfig,
);

// @ts-ignore
if (import.meta.hot) {
  // @ts-ignore
  import.meta.hot.accept(acceptHMRUpdate(usePaymentsStore, import.meta.hot));
}
